import React, { type FC } from 'react'
import { Divider } from '@mui/material'

import { areArrayEquals } from '../../../../utils'

import { selectExplorerMonitoredTopics, Translation } from '../../../../domain'

import { Delay } from '../../common'
import { useAppState } from '../../State'
import { Section } from '../Section'
import { TableHead } from './Header'
import { TableLines } from './Lines'

const Content: FC = () => {
    const monitoredTopics = useAppState(selectExplorerMonitoredTopics, areArrayEquals)

    return (
        <Delay delay={300}>
            <TableLines topics={monitoredTopics} />
        </Delay>
    )
}

export const MonitoredTopics: FC = () => (
    <Section data-testid="monitoredTopics" title={Translation.MONITORED_TOPICS}>
        <Divider />
        <TableHead />
        <Content />
    </Section>
)
